import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTaskItem } from '../api/tasks';
import type { TaskFormValues } from '../types';
import { notification } from 'antd';
import { ApiError } from '../../../lib/api/error';

export function useCreateTaskItem(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: TaskFormValues) => createTaskItem(data),
    onSuccess: () => {
      notification.success({ message: 'Task created successfully' });
      void queryClient.invalidateQueries({ queryKey: ['taskItems'] });
      void queryClient.invalidateQueries({ queryKey: ['task-dashboard'] });
      onSuccess?.();
    },
    onError: (error: unknown) => {
      notification.error({ message: ApiError.fromAxiosError(error).message });
    },
  });
}
